import { InjectionToken, inject } from '@angular/core';

import { EnvironmentConfig } from '../../client-config/index';

export const SPRITE_PATH_TOKEN = new InjectionToken('sprite path token', {
    providedIn: 'root',
    factory: () => {
        const environment = inject(EnvironmentConfig).configuration;
        const cmsImagesPath = `${environment.CMS_ENDPOINT}/${environment.BRAND}/svg-images/sprite`;

        return {
            initial: `${cmsImagesPath}/initial`, // always included to /initial-data
            featured: `${cmsImagesPath}/featured`, // included to /initial-data/desktop
            additional: `${cmsImagesPath}/additional`,
            virtual: `${cmsImagesPath}/virtual`,
            timeline: `${cmsImagesPath}/timeline`,
        };
    },
});
